/// <reference path="../../WebUI/typings/tsd.d.ts" />

import { clientAppSettings } from "./Models/ClientAppSettings";
import { ControllerBase } from "./Controllers/ControllerBase";
import Rest = require("./Generated/RestClient");
import { parseQuery } from "../../Intercom.ReactUI/Utils/Url";
import { TrackingCookieConsent } from './Utils/TrackingCookieConsent';

import { Resources } from './Resources/Intercom.Resources.DevPortal';
import { Culture } from './Resources/Culture';
import { CultureUtility } from './Resources/CultureUtility';

declare var WL: any;

export class DevPortalAppBase extends SimpleMvc.App {
    public signedInUser: Rest.AuthData;
    public availableChannels: Rest.Channel[];
    public trackingCookieConsent = new TrackingCookieConsent();
    public announcements: IAnnouncements;

    private scrollHandlers: { (element: Element): void }[] = [];

    public scrolled(element: Element) {
        [...this.scrollHandlers].forEach((handler) => handler(element));
    }

    public onscroll(handler: (element) => void): { (): void } {
        let isSubscribed = true;
        this.scrollHandlers.push(handler);
        const unsubscribe = () => {
            if (!isSubscribed) {
                return;
            }
            isSubscribed = false;
            const index = this.scrollHandlers.indexOf(handler);
            this.scrollHandlers.splice(index, 1);
        }
        return unsubscribe;
    }

    constructor() {
        super({
            appBody: document.getElementById("app-body"),
            useHistory: true
        });

        // Ibiza/Azure sends us the preferred language in a query string - if present parse that out and set it for use on other pages.
        const queryParams: { [key: string]: string } = parseQuery(window.location.search.substring(1));
        if (queryParams) {
            CultureUtility.setLocale(queryParams["l"]);
            if (CultureUtility.displayLanguage) {
                Culture.Lang = CultureUtility.displayLanguage;
            }
            if (CultureUtility.cultureCode) {
                Culture.CultureCode = CultureUtility.cultureCode;
            }
        }

        Rest.showNetworkIcon = show => {
            var $loading = $(".loading-animation");
            if (show) {
                $loading.toggleClass("loading", true);
            }
            else {
                $loading.toggleClass("loading", false);
            }
        };

        if (clientAppSettings.applicationPath !== "/") {
            Rest.urlPrefix = clientAppSettings.applicationPath;
        }

        window.onbeforeunload = () => this.onBeforeUnloadHandler();
    }

    private onBeforeUnloadHandler(): string {
        let currentController = <ControllerBase>this.getRouter().getCurrentController();
        if ($.isFunction(currentController.hasUnsavedChanges) && currentController.hasUnsavedChanges())
            return Resources.unsavedChangesWillBeLost;
        return undefined;  // Note: can't return null here. We have to (implicitly or explicitly) return undefined to not prompt the user.
    }

    public isFeatureFlighted(feature: string): boolean {
        return clientAppSettings.flightedFeatures.indexOf(feature) != -1;
    }

    public isUserFeatureFlighted(feature: string): boolean {
        return this.isFeatureFlighted(feature);
    }

    public setFeatureFlighting(feature: string, turnOn: boolean): void {
        let index = clientAppSettings.flightedFeatures.indexOf(feature);
        if (turnOn) {
            if (index === -1) {
                clientAppSettings.flightedFeatures.push(feature);
            }
        }
        else {
            if (index !== -1) {
                clientAppSettings.flightedFeatures.splice(index, 1);
            }
        }
    }

    public isSubmitForReviewFlighted(): boolean {
        return this.isFeatureFlighted('SubmitForReview');
    }
}

export interface IAnnouncements {
    isFeatureFlighted: boolean;
    all: Rest.Announcement[];
    addShown: () => void;
    shownIdCount: { [id: string]: number };
}



// WEBPACK FOOTER //
// ./Client/DevPortalAppBase.ts